var constants = require('../constants');

var modalActions = (function() {

  var _showModal = function(type, props) {
    return {
      type: constants.SHOW_MODAL,
      payload: {
        type: type,
        props: props
      }
    }
  }

  var _hideModal = function() {
    return {
      type: constants.HIDE_MODAL
    }
  }

  return {
    showModal: _showModal,
    hideModal: _hideModal
  }
})();

module.exports = modalActions;



// WEBPACK FOOTER //
// ./src/common/modules/modals/actions/modal.js